import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Snackbar,
    Table,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
    Typography,
    LinearProgress,
} from '@material-ui/core'
import {useTranslation} from 'react-i18next'
import React, {useEffect, useRef, useState, ChangeEvent} from 'react'
import {Head} from 'components/table/Head'
import {AppTable, Field} from 'components/table'
import {Body} from 'components/table/Body'
import {Actions} from 'components/table/types'
import uploadIcon from '../../assets/table-icons/upload-icon.svg'
import {GenericTooltip} from 'components/generic-tooltip'
import {File as F, FileDTO} from '../../modules/files/models/File'
import {dataToBase64, downloadFile} from 'common/files/file'
import {v4 as uuidv4, NIL as nullId} from 'uuid'
import {getAuthContainer} from 'container/auth-modules'
import {AuthService} from 'modules/auth/services/AuthService'
import {AUTH_SERVICE_KEY} from 'modules/auth'
import styles from './SecondStep.module.css'
import {getIndividualContainer} from 'container/individual-module'
import {IndividualService} from 'modules/individuals/services/IndividualService'
import {INDIVIDUAL_SERVICE_KEY} from 'modules/individuals'
import {emptyIndividualDTO, Individual, IndividualDTO, Informativity,} from 'modules/individuals/models/Individual'
import {Individuals, individualsTitle} from 'modules/individuals/enums/Individuals'
import {Query, QueryParam} from 'common/api/Query'
import deleteIcon from '../../assets/table-icons/delete-icon.svg'
import downloadIcon from '../../assets/table-icons/download-icon.svg'
import {FormAction, FormActions} from '../../common/utils/form-generation'
import {commonStyles} from '../../common/styles/Styles'
import {convertToProjectDTO, ProjectAnalysis} from 'modules/projects/models/Project'
import {getProjectContainer} from 'container/project-module'
import {ProjectService} from 'modules/projects/services/ProjectService'
import {PROJECT_SERVICE_KEY} from 'modules/projects'
import ArrowBack from '@material-ui/icons/ArrowBack'
import ArrowForward from '@material-ui/icons/ArrowForward'
import {Modal} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import {FinalStatus, Status, statusTitle} from '../../modules/individuals/enums/Status'
import {ChildGenderPGD, childGendersPGD} from '../../modules/users/enums/GenderType'
import {COLOR_CLINICS} from 'routes/color-constants'
import {getFileContainer} from 'container/file-module'
import {FileService} from 'modules/files/services/FileService'
import {FILE_SERVICE_KEY} from 'modules/files'
import {firstValueFrom} from 'rxjs'
import {customOrder} from 'modules/users/enums/RoleType'
import {ExpandMore} from "@material-ui/icons";
import {Alert} from "@material-ui/lab";
import { Permission } from 'common/enums/Permissions'
import { getPatientContainer } from 'container/patient-module'
import { PatientService } from 'modules/patients/services/PatientService'
import { PATIENT_SERVICE_KEY } from 'modules/patients'
import { getMutationsPositionContainer } from 'container/mutationsPositions-module'
import { MUTATIONS_POSITION_SERVICE_KEY } from 'modules/mutationsPosition'
import { MutationsPositionService } from 'modules/mutationsPosition/services/MutationsPositionService'
import { MutationsPosition } from 'modules/mutationsPosition/models/MutationsPosition'
import { DirectTestingService } from 'modules/directTesting/services/DirectTestingService'
import { getDirectTestingContainer } from 'container/directTesting-module'
import { DIRECT_TESTING_SERVICE_KEY } from 'modules/directTesting'
import { DirectTestingDTO } from 'modules/directTesting/models/DirectTesting'

const DEFAULT_ROW_KEY = 'id'


type SecondStepProps = {
    increaseStep: () => void
    decreaseStep: () => void
    deleteFiles: () => void
    setData: (data: any) => void
    setIsViewResult: (bool: boolean) => void
    project?: ProjectAnalysis
    setProject: (s: ProjectAnalysis) => void
    currentStep: number
    setIndividuals: (inf: Individual[]) => void
    setViewIGV: (b: boolean) => void
    setVariants: (v: MutationsPosition[]) => void
}

const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)
const individualService = getIndividualContainer().get<IndividualService>(INDIVIDUAL_SERVICE_KEY)
const projectService = getProjectContainer().get<ProjectService>(PROJECT_SERVICE_KEY)
const fileService = getFileContainer().get<FileService>(FILE_SERVICE_KEY)
const patientService = getPatientContainer().get<PatientService>(PATIENT_SERVICE_KEY)
const mutationService = getMutationsPositionContainer().get<MutationsPositionService>(MUTATIONS_POSITION_SERVICE_KEY)
const directDetectionService = getDirectTestingContainer().get<DirectTestingService>(DIRECT_TESTING_SERVICE_KEY)

interface File2 extends FileDTO {
    individual: Individuals
}

export const SecondStep = (props: SecondStepProps) => {
    const {t} = useTranslation()
    const [individuals, setIndividuals] = useState<Individual[]>([])
    const individualOptions: any[] = [
        Individuals.FEMALE_MOTHER,
        Individuals.FEMALE_FATHER,
        Individuals.FEMALE_BROTHER,
        Individuals.MALE_MOTHER,
        Individuals.MALE_FATHER,
        Individuals.FEMALE,
        Individuals.MALE,
        Individuals.CHILD,
        '',
    ]
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const statusOptions = [Status.NonCarrier, Status.Carrier, Status.Affected, Status.Null]
    const [lastAdded, setLastAdded] = useState<IndividualDTO>(emptyIndividualDTO(props.project?.id || ''))
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const fileInputRef2 = useRef<HTMLInputElement | null>(null)
    const fileInputRefBAMBAI = useRef<HTMLInputElement | null>(null);
    const [modalDeleteOpened, setModalDeleteOpened] = useState<boolean>(false)
    const [modalReplaceOpened, setModalReplaceOpened] = useState<boolean>(false)
    const [currentIndividual, setCurrentIndividual] = useState<Individual>()
    const [informativities, setInformativities] = useState<Informativity[]>([])
    const [project, setProject] = useState<ProjectAnalysis | undefined>(props.project)
    const [projectName, ] = useState<String>(props.project?.name || '')
    const [modalPreviewOpened, setModalPreviewOpened] = useState<boolean>(false)
    const styles2 = commonStyles()
    const [showSpinner, setShowSpinner] = useState<boolean>(false)
    const [data, setData] = useState<any>()
    const [dataLoaded, setDataLoaded] = useState<boolean>(false)
    const [isViewData, setIsViewData] = useState<boolean>(props.project?.resultTableID != "00000000-0000-0000-0000-000000000000")
    const [modalSaveInformativityOpened, setModalSaveInformativityOpened] = useState<boolean>(false)
    const [nameInformativity, setNameInformativity] = useState<string>('')
    const [bamFiles, setBamFiles] = useState<File2[]>([])
    const [isLoadingBamFiles, setIsLoadingBamFiles] = useState<boolean>(true)
    const [isLoadingBamFiles2, setIsLoadingBamFiles2] = useState<boolean>(false)
    const [currentFileIndividual, setCurrentFileIndividual] = useState<Individuals>()
    const [err, setErr] = useState<string>()
    const [open, setOpen] = useState<boolean>(false)
    const [childIndividual, setChildIndividual] = useState<IndividualDTO>()
    const [fatherStatus, setFatherStatus] = useState<Status>()
    const [motherStatus, setMotherStatus] = useState<Status>()
    const [modalChildOriginAffected, setModalChildOriginAffected] = useState<boolean>(false)
    

    const [openPaternalModalVariant, setOpenPaternalModalVariant] = useState<boolean>(false)
    const [openModalMaternalVariant, setOpenMaternalModalVariant] = useState<boolean>(false)
    const [openModalChildlVariant, setOpenChildModalVariant] = useState<boolean>(false)


    const [variants, setVariants]= useState<MutationsPosition[]>([])
    const [maternalVar, setMaternalVar]= useState<MutationsPosition[]>([])
    const [paternalVar, setPaternalVar]= useState<MutationsPosition[]>([])
    const [childVar, setChildVar]= useState<string[]>([])

    const [disclaimerBambai, setDisclaimerBambai] = useState<boolean>(false)
    
    const [newDirectTesting, setNewDirectTesting] = useState<DirectTestingDTO[]>([])


    
    const [childFinalStatus, setChildFinalStatus] = useState<FinalStatus>()

    const canEdit=  (authService.userCan(Permission.editUsers)? true  : authService.get().id === props.project?.userID)


    const refreshData = async () => {
        setIsLoadingBamFiles(true);
        setIsLoadingBamFiles2(true);

        let auxBam: File2[] = [];
        const promises = individuals.map(async (ind) => {
            let baiFile: File2 = {
                id: uuidv4(),
                name: '',
                data: '',
                size: 0,
                mimeType: '',
                extension: '.bai',
                ownerID: '',
                individual: ind.individual,
                pgType: ''
            };
            if (ind.baiFileID != '') {
                let auxBaiFile = await firstValueFrom(fileService.getBAIModel(ind.baiFileID));
                if (auxBaiFile) {
                    baiFile = {
                        id: auxBaiFile.id,
                        name: auxBaiFile.name,
                        data: auxBaiFile.data,
                        size: auxBaiFile.size,
                        mimeType: auxBaiFile?.mimeType,
                        extension: auxBaiFile?.extension,
                        ownerID: auxBaiFile?.ownerID,
                        individual: ind.individual,
                        pgType: ''
                     
                    };
                }
                auxBam.push(baiFile);
            }


                        // Obtener el archivo BIM con lógica de reintentos
                        let bimFile: File2 = {
                            id: uuidv4(),
                            name: '',
                            data: '',
                            size: 0,
                            mimeType: '',
                            extension: 'bam',
                            ownerID: '',
                            individual: ind.individual,
                            pgType: ''
                        };
                
                        if (ind.bimFileID !== '') {
                            let auxBimFile = null;
                            let attempts = 0;
                            
                            // Intentar hasta 3 veces si auxBimFile es null
                            while (attempts < 4 && !auxBimFile) {
                                try {
                                    auxBimFile = await firstValueFrom(fileService.getBIMModel(ind.bimFileID));
                                    
                                    if (auxBimFile) {
                                        bimFile = {
                                            id: auxBimFile.id,
                                            name: auxBimFile.name,
                                            data: auxBimFile.data,
                                            size: auxBimFile.size,
                                            mimeType: auxBimFile?.mimeType,
                                            extension: auxBimFile?.extension,
                                            ownerID: auxBimFile?.ownerID,
                                            individual: ind.individual,
                                            pgType: ''
                                        };
                                    }
                                } catch (error) {
                                    console.error(`Error al obtener BIM File en el intento ${attempts + 1}:`, error);
                                }
                
                                // Esperar 1 segundo antes de intentar de nuevo si el archivo BIM aún es null
                                if (!auxBimFile) {
                                    await new Promise(resolve => setTimeout(resolve, 5000));
                                }
                
                                attempts++;
                            }
                
                            // Si después de 3 intentos no se consigue, no agregamos el archivo BIM
                            if (auxBimFile) {
                                auxBam.push(bimFile);
                            } 
                        }
                
                        // Si no hay archivo BIM y tampoco hay archivo BAI, agregamos el archivo BAI
                        if (ind.bimFileID === '' && ind.baiFileID === '') {
                            auxBam.push(baiFile);
                        }

        });

        await Promise.all(promises);
    
        // Ordenar y establecer los archivos BAM en el estado
        setBamFiles(auxBam.sort((a, b) => customOrder[a.individual] - customOrder[b.individual]));
        setIsLoadingBamFiles(false);
        setIsLoadingBamFiles2(false);
    };
    useEffect(() => {
        if (individuals.length == 0) {
            setIsLoadingBamFiles(false)
            return
        }

        if (!isLoadingBamFiles) {
            return
        }

        refreshData()
    }, [individuals, isLoadingBamFiles])


    const openSaveInformativityModal = () => {
        let informativityName = informativities.find((i) => i.id == project?.informativityID)?.name
        props.setIndividuals(individuals)
        
         if((informativityName == "" || informativityName == undefined ||informativityName == "New") && canEdit ){
             setModalSaveInformativityOpened(true)}
             else{
                saveInformativity()
             }
    }

    const saveInformativity = () => {
        let informativityID = project?.informativityID
        let informativityName = informativities.find((i) => i.id == project?.informativityID)?.name
        if(!authService.get().permissions.find((p) => p === Permission.deleteClinics)){


            let informativity: Informativity = {
                id: informativityID || '',
                name: nameInformativity || informativityName || '',
                clinicid: authService.get().clinics[0],
                projectid: props.project?.id,
                pgtype: 'pgd',
            }
            individualService.updateInformativity(informativity).subscribe((res) => {
                setModalSaveInformativityOpened(false)
            })}else{
                patientService.getByID(project?.patientID || '').subscribe((res) => {
                    
                    let informativity: Informativity = {
                        id: informativityID || '',
                        name: nameInformativity || informativityName || '',
                        clinicid: res?.clinicID,
                        projectid: props.project?.id,
                        pgtype: 'pgd',
                    }
                    individualService.updateInformativity(informativity).subscribe((res) => {
                        setModalSaveInformativityOpened(false)
                    })
                })}
        handleContinue()
    }

    const handleNameInformativity = (name: string, value: string) => {
        setNameInformativity(value)
    }

    const closeModalInformativity = () => {
        setModalSaveInformativityOpened(false)
    }

    const actionReplaceModalInformativity: FormAction[] = [
        {
            label: t('close'),
            handleAction: closeModalInformativity,
        },
    ]

    const closeModalChildGender = () => {
        setModalChildGender(false)
    }


    const closeVarianModal = () => {
        setOpenPaternalModalVariant(false)
        setOpenMaternalModalVariant(false)
        setOpenChildModalVariant(false)

    }

    const closeModalChildCarrierAffected = () => {
        setModalChildOriginAffected(false)
    }

    const actionReplaceModalChildGender: FormAction[] = [
        {
            label: t('close'),
            handleAction: closeModalChildGender,
        },
    ]

    const actionVariantModal: FormAction[] = [
        {
            label: t('close'),
            handleAction: closeVarianModal,
        },
    ]

    const actionReplaceModalCarrierAfected: FormAction[] = [
        {
            label: t('close'),
            handleAction: closeModalChildCarrierAffected,
        },
    ]

    const refreshInformativities = () => {
         // new QueryParam('projectid' , project?.id || '')  
        //si es admin no se filtra por clinicid
            
            individualService.getInformativityList(new Query({query:  [new QueryParam('projectid' , project?.id || ''),
                new QueryParam('pgtype' , 'pgd')]})).subscribe((res) => {
          
            setInformativities(res.items)
        })
    }

    useEffect(() => {
        refreshInformativities()
    }, [])

    useEffect(() => {
        if (!isLoading) return

        
        individualService
            .getFilteredList(
                new Query({
                    query: [new QueryParam('informativityID', props.project?.informativityID || '')],
                })
            )
            .subscribe((res) => {
                res.items.map(i => {
                    if(i.individual === Individuals.MALE) setFatherStatus(i.status)
                    if(i.individual === Individuals.FEMALE) setMotherStatus(i.status)
                    if(i.individual === Individuals.CHILD) setChildIndividual(i)
                    return null
                })

                setIndividuals(res.items)
                setIsLoading(false)
                setShowSpinner(false)
                setIsLoadingBamFiles(true)
            })
            if (props.project?.id) {
                projectService.getByID(props.project?.id).subscribe(res =>{
                   setIsViewData(res?.resultTableID == "00000000-0000-0000-0000-000000000000")
                })
            }
            
    }, [isLoading])

    const fields: Field<any>[] = [
        {
            sortable: false,
            searchable: false,
            label: t('individual'),
            name: 'individual',
        },
        {
            sortable: false,
            searchable: false,
            label: t('fileName'),
            name: 'fileName',
        },
        {
            sortable: false,
            searchable: false,
            label: t('status'),
            name: 'status',
        },
        {
            sortable: false,
            searchable: false,
            label: t('mutation'),
            name: 'mutation',
        },
        {
            sortable: false,
            searchable: false,
            label: t('color'),
            name: 'color',
        },
    ]

    const fieldsFiles: Field<File2>[] = [
        {
            sortable: false,
            searchable: false,
            label: t('name'),
            name: 'name',
        },
        {
            sortable: false,
            searchable: false,
            label: t('type'),
            name: 'extension',
        },
        {
            sortable: false,
            searchable: false,
            label: t('individualF'),
            name: 'individual',
            renderFunc: (f, item) => individualsTitle()[item.individual],
        },
    ]

    const changeFile = (f: File) => {
        setLastAdded(Object.assign({...lastAdded}, {file: f}))
        fileInputRef.current?.click()
    }

    const changeFileField = (f: File2) => {
        // Llamar al input para seleccionar ambos archivos (bam y bai)
        if (fileInputRefBAMBAI.current) {
            setCurrentFileIndividual(f.individual)
            fileInputRefBAMBAI.current.click();
        }
    }

    const actions: Actions<any> = {
        actionsColumn: t('Actions'),
        items: [
            {
                handler: changeFile,
                icon: uploadIcon,
                label: t('upload'),
            },
        ],
    }

    const actionsFiles: Actions<File2> = {
        actionsColumn: t('Actions'),
        items: [
            {
                handler: (item: File2) => changeFileField(item),
                icon: uploadIcon,
                label: t('upload'),
            },
        ],
    }

    const validDirectDetection = () => {
        var isDisable: boolean = true
        if (variants.length === 0) isDisable = false
        variants.forEach(variant => {
            if (variant.type === "SNP") isDisable = false
            else if ((variant.end-variant.start)<15) isDisable = false
        })

        return isDisable
        
    }

    const aplyVariantDescription = (status: number) => {
        setNewDirectTesting([])
        if (status === Status.NonCarrier){
            variants.map(v => {
                if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id &&  dt.mutationID === v.id)){
                    let aux: DirectTestingDTO[] = newDirectTesting
                    aux.push({
                        id: uuidv4(),
                        individualID: lastAdded.id,
                        mutationID: v.id,
                        directTesting: 0,
                        status: Status.NonCarrier
                    })

                    setNewDirectTesting(aux)
                }
            })
             setLastAdded(Object.assign({...lastAdded}, {'mutation': '', 'status': status}))
            return
            }

         let variantDescriptionAux: string = ''
          
        
        if (lastAdded.individual === Individuals.FEMALE ||
            lastAdded.individual === Individuals.FEMALE_FATHER ||
            lastAdded.individual === Individuals.FEMALE_MOTHER ||
            lastAdded.individual === Individuals.FEMALE_BROTHER){
            for(let i = 0 ; i < maternalVar.length ; i++) {
                if (i === 0) {
                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id &&  dt.mutationID === maternalVar[i].id)){
                        let aux: DirectTestingDTO[] = newDirectTesting
                        aux.push({
                            id: uuidv4(),
                            individualID: lastAdded.id,
                            mutationID: maternalVar[i].id,
                            directTesting: 0,
                            status: Status.Carrier
                        })
    
                        setNewDirectTesting(aux)
                    }
                    variantDescriptionAux = maternalVar[i].description}
                else {
                    
                        if(maternalVar[i].cis) {
                            if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id &&  dt.mutationID === maternalVar[i].id)){
                                let aux: DirectTestingDTO[] = newDirectTesting
                                aux.push({
                                    id: uuidv4(),
                                    individualID: lastAdded.id,
                                    mutationID: maternalVar[i].id,
                                    directTesting: 0,
                                    status: Status.Carrier
                                })
            
                                setNewDirectTesting(aux)
                            }
                            variantDescriptionAux +=  ';' + maternalVar[i].description}
                        if(maternalVar[i].trans) {
                            switch (status) {
                                case Status.Affected: 
                                setLastAdded(Object.assign({...lastAdded}, {'status': status}))
                                    variantDescriptionAux +=  '/' + maternalVar[i].description
                                   
                    
                                    break 
                                case Status.Carrier:
                                    setLastAdded(Object.assign({...lastAdded}, {'status': status}))
                                    setOpenMaternalModalVariant(true)
                                    break
                            }
                        }
                    
                }

                if(status === Status.Affected){
                    setLastAdded(Object.assign({...lastAdded}, {'status': status}))
                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id &&  dt.mutationID === maternalVar[i].id)){
                        let aux: DirectTestingDTO[] = newDirectTesting
                        aux.push({
                            id: uuidv4(),
                            individualID: lastAdded.id,
                            mutationID: maternalVar[i].id,
                            directTesting: 0,
                            status: Status.Carrier
                        })
    
                        setNewDirectTesting(aux)
                    }
                }
               
            }
            setLastAdded(Object.assign({...lastAdded}, {'mutation': variantDescriptionAux, 'status': status}))

            
        }

        if (lastAdded.individual === Individuals.MALE || lastAdded.individual === Individuals.MALE_FATHER ||lastAdded.individual === Individuals.MALE_MOTHER){

            for(let i = 0 ; i < paternalVar.length ; i++) {
                if (i === 0) {
                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === paternalVar[i].id)){
                        let aux: DirectTestingDTO[] = newDirectTesting
                        aux.push({
                            id: uuidv4(),
                            individualID: lastAdded.id,
                            mutationID: paternalVar[i].id,
                            directTesting: 0,
                            status: Status.Carrier
                        })

                        setNewDirectTesting(aux)
                    }
                    variantDescriptionAux = paternalVar[i].description}
                else {
                    if(paternalVar[i].cis){
                        if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === paternalVar[i].id)){
                            let aux: DirectTestingDTO[] = newDirectTesting
                            aux.push({
                                id: uuidv4(),
                                individualID: lastAdded.id,
                                mutationID: paternalVar[i].id,
                                directTesting: 0,
                                status: Status.Carrier
                            })
    
                            setNewDirectTesting(aux)
                        }
                        variantDescriptionAux +=  ';' + paternalVar[i].description
                    }
                    if(paternalVar[i].trans) {
                        switch (status) {
                            case Status.Affected: 
                    setLastAdded(Object.assign({...lastAdded}, {'status': status}))

                                variantDescriptionAux +=  '/' + paternalVar[i].description
                                break
                            case Status.Carrier:
                                setOpenPaternalModalVariant(true)
                                break
                        }
                    }   
                }

                if(status === Status.Affected){
                    setLastAdded(Object.assign({...lastAdded}, {'status': status}))

                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === paternalVar[i].id)){
                        let aux: DirectTestingDTO[] = newDirectTesting
                        aux.push({
                            id: uuidv4(),
                            individualID: lastAdded.id,
                            mutationID: paternalVar[i].id,
                            directTesting: 0,
                            status: Status.Carrier
                        })

                        setNewDirectTesting(aux)
                    }
                }
            }
            setLastAdded(Object.assign({...lastAdded}, {'mutation': variantDescriptionAux, 'status': status}))

        }

        if (lastAdded.individual === Individuals.CHILD){
            setLastAdded(Object.assign({...lastAdded}, {'status': status}))

            if ( paternalVar.length === 1 && maternalVar.length === 0){
                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === paternalVar[0].id)){
                        let aux: DirectTestingDTO[] = newDirectTesting
                        aux.push({
                            id: uuidv4(),
                            individualID: lastAdded.id,
                            mutationID: paternalVar[0].id,
                            directTesting: 0,
                            status: Status.Carrier
                        })

                        setNewDirectTesting(aux)
                    }
                variantDescriptionAux = paternalVar[0].description
            }
            else if ( paternalVar.length === 0 && maternalVar.length === 1) {
                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID ===  maternalVar[0].id)){
                        let aux: DirectTestingDTO[] = newDirectTesting
                        aux.push({
                            id: uuidv4(),
                            individualID: lastAdded.id,
                            mutationID:  maternalVar[0].id,
                            directTesting: 0,
                            status: Status.Carrier
                        })

                        setNewDirectTesting(aux)
                    }
                variantDescriptionAux =  maternalVar[0].description}
            else if (paternalVar.length === 1 && maternalVar.length === 1){
                switch (status) {
                    case Status.Affected: 

                        variantDescriptionAux = maternalVar[0].description  + '/' + paternalVar[0].description
                        if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === paternalVar[0].id)){
                            let aux: DirectTestingDTO[] = newDirectTesting
                            aux.push({
                                id: uuidv4(),
                                individualID: lastAdded.id,
                                mutationID: paternalVar[0].id,
                                directTesting: 0,
                                status: Status.Affected
                            })
    
                            setNewDirectTesting(aux)
                        }
                        if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === maternalVar[0].id)){
                            let aux: DirectTestingDTO[] = newDirectTesting
                            aux.push({
                                id: uuidv4(),
                                individualID: lastAdded.id,
                                mutationID: maternalVar[0].id,
                                directTesting: 0,
                                status: Status.Affected

                            })
    
                            setNewDirectTesting(aux)
                        }
                        break
                    case Status.Carrier:

                        let aux: string[] = []
                        aux.push(maternalVar[0].description)
                        aux.push(paternalVar[0].description)

                        setChildVar(aux)

                        setOpenChildModalVariant(true)
                        break
                }
            }
            else if(paternalVar.length > 1 && maternalVar.length > 1){
                switch (status) {
                    case Status.Carrier: 
                        if (paternalVar[1].trans && !maternalVar[1].trans){
                            let aux: string[] = []
                            aux.push(maternalVar[0].description + ';' + maternalVar[1].description )
                            aux.push(paternalVar[0].description)
                            aux.push(paternalVar[1].description)

        
                            setChildVar(aux)
        
                            setOpenChildModalVariant(true)
                        }
                        if (maternalVar[1].trans && !paternalVar[1].trans){
                            let aux: string[] = []
                            aux.push(maternalVar[0].description )
                            aux.push(maternalVar[1].description)
                            aux.push(paternalVar[0].description + ';' + paternalVar[1].description)

            
                            setChildVar(aux)
            
                            setOpenChildModalVariant(true)
                        }
                        if(maternalVar[1].trans && paternalVar[1].trans){
                            let aux: string[] = []
                            aux.push(maternalVar[0].description)
                            aux.push(maternalVar[1].description )
                            aux.push(paternalVar[0].description )
                            aux.push(paternalVar[1].description)
                            
                            setChildVar(aux)
            
                            setOpenChildModalVariant(true)
                        }
                        if(!maternalVar[1].trans && !paternalVar[1].trans) {
                            let aux: string[] = []
                            aux.push(maternalVar[0].description + ';' +maternalVar[1].description )
                            aux.push(paternalVar[0].description+ ';' +paternalVar[1].description)
                            
                            setChildVar(aux)
            
                            setOpenChildModalVariant(true)
                        }
                        break
                    case Status.Affected:
                        if (paternalVar[1].trans && !maternalVar[1].trans){
                            let aux: string[] = []
                            aux.push(maternalVar[0].description + ';' + maternalVar[1].description + '/' + paternalVar[0].description)
                            aux.push(maternalVar[0].description + ';' + maternalVar[1].description + '/' + paternalVar[1].description)
        
                            setChildVar(aux)
        
                            setOpenChildModalVariant(true)
                        }
                        if (maternalVar[1].trans && !paternalVar[1].trans){
                            let aux: string[] = []
                            aux.push(maternalVar[0].description + '/' + paternalVar[0].description + ';' + paternalVar[1].description)
                            aux.push(maternalVar[1].description + '/' + paternalVar[0].description + ';' + paternalVar[1].description)
            
                            setChildVar(aux)
            
                            setOpenChildModalVariant(true)
                        }
                        if(maternalVar[1].trans && paternalVar[1].trans){
                            let aux: string[] = []
                            aux.push(maternalVar[0].description + '/' + paternalVar[0].description)
                            aux.push(maternalVar[1].description + '/' + paternalVar[0].description)
                            aux.push(maternalVar[0].description + '/' + paternalVar[1].description)
                            aux.push(maternalVar[1].description + '/' + paternalVar[1].description)
                            setChildVar(aux)
            
                            setOpenChildModalVariant(true)
                        }
                        if(!maternalVar[1].trans && !paternalVar[1].trans) {
                            variantDescriptionAux = maternalVar[0].description + ';' + maternalVar[1].description + '/' + paternalVar[0].description + ';' + paternalVar[1].description
                        }
                        setOpenChildModalVariant(true)
                        break
                }
              
               
            }
            else if (paternalVar.length > 1 ){
                if ( maternalVar.length === 1) {
                    if (!paternalVar[1].trans) { 
                        switch (status) {
                            case Status.Affected: 
                                variantDescriptionAux = paternalVar[0].description + "/" + paternalVar[1].description + ';' + maternalVar[0].description 
                                paternalVar.forEach(pv => {

                                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === pv.id)){
                                        let aux: DirectTestingDTO[] = newDirectTesting
                                        aux.push({
                                            id: uuidv4(),
                                            individualID: lastAdded.id,
                                            mutationID: pv.id,
                                            directTesting: 0,
                                            status: Status.Carrier
                                        })
                
                                        setNewDirectTesting(aux)
                                    }
                                })
                                if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === maternalVar[0].id)){
                                    let aux: DirectTestingDTO[] = newDirectTesting
                                    aux.push({
                                        id: uuidv4(),
                                        individualID: lastAdded.id,
                                        mutationID: maternalVar[0].id,
                                        status: Status.Carrier,
                                        directTesting: 0
                                    })
            
                                    setNewDirectTesting(aux)
                                }
                                break
                            case Status.Carrier:
                                let aux: string[] = []
                                aux.push(maternalVar[0].description)
                                aux.push(paternalVar[0].description + ";" + paternalVar[1].description)


                                setChildVar(aux)

                                setOpenChildModalVariant(true)
                                break
                        }
                    } 
                    if(paternalVar[1].trans) {
                        switch (status) {
                            case Status.Affected: 
                            let aux1: string[] = []
                            aux1.push( maternalVar[0].description + "/" +paternalVar[0].description )
                            aux1.push( maternalVar[0].description + "/" +paternalVar[1].description )



                            setChildVar(aux1)

                            setOpenChildModalVariant(true)
                            break
                            case Status.Carrier:
                                let aux: string[] = []
                                aux.push(maternalVar[0].description)
                                aux.push(paternalVar[0].description)
                                aux.push(paternalVar[1].description)

                                setChildVar(aux)

                                setOpenChildModalVariant(true)
                                break
                        }
                    }
                 } else if ( maternalVar.length === 0) {
                        if (paternalVar[1].cis){  
                            variantDescriptionAux = paternalVar[0].description + ';' + paternalVar[1].description
                            paternalVar.forEach(pv => {

                                if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === pv.id)){
                                    let aux: DirectTestingDTO[] = newDirectTesting
                                    aux.push({
                                        id: uuidv4(),
                                        individualID: lastAdded.id,
                                        mutationID: pv.id,
                                        directTesting: 0,
                                        status: Status.Carrier
                                    })
            
                                    setNewDirectTesting(aux)
                                }
                            })
                        }
                        else if (paternalVar[1].trans) {
                            let aux: string[] = []
                            aux.push(paternalVar[0].description)
                            aux.push(paternalVar[1].description)

                            setChildVar(aux)

                            setOpenChildModalVariant(true)
                        }
   
                    } 

            }else if (maternalVar.length > 1){
                if ( paternalVar.length === 1) {
                    if (maternalVar[1].cis) { 
                        switch (status) {
                            case Status.Affected: 
                                variantDescriptionAux = maternalVar[0].description + ";" + maternalVar[1].description + '/' + paternalVar[0].description 
                                maternalVar.forEach(pv => {

                                    if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === pv.id)){
                                        let aux: DirectTestingDTO[] = newDirectTesting
                                        aux.push({
                                            id: uuidv4(),
                                            individualID: lastAdded.id,
                                            mutationID: pv.id,
                                            directTesting: 0,
                                            status: Status.Carrier
                                        })
                
                                        setNewDirectTesting(aux)
                                    }
                                })
                                if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === paternalVar[0].id)){
                                    let aux: DirectTestingDTO[] = newDirectTesting
                                    aux.push({
                                        id: uuidv4(),
                                        individualID: lastAdded.id,
                                        mutationID: paternalVar[0].id,
                                        directTesting: 0,
                                        status: Status.Carrier
                                    })
            
                                    setNewDirectTesting(aux)
                                }
                                break
                            case Status.Carrier:
                                let aux: string[] = []
                                aux.push(paternalVar[0].description)
                                aux.push(maternalVar[0].description + ";" + maternalVar[1].description)

                                setChildVar(aux)

                                setOpenChildModalVariant(true)
                                break
                        }
                    } 
                    if(maternalVar[1].trans) {
                        switch (status) {
                            case Status.Affected: 
                            let aux1: string[] = []
                            aux1.push(maternalVar[0].description + "/" + paternalVar[0].description)
                            aux1.push(maternalVar[1].description + "/" + paternalVar[0].description)



                            setChildVar(aux1)

                            setOpenChildModalVariant(true)
                            break
                            case Status.Carrier:
                                let aux: string[] = []
                                aux.push(paternalVar[0].description)
                                aux.push(maternalVar[0].description)
                                aux.push(maternalVar[1].description)

                                setChildVar(aux)

                                setOpenChildModalVariant(true)
                                break
                        }
                    }
                 } else if ( paternalVar.length === 0) {
                        if (maternalVar[1].cis) {
                             variantDescriptionAux = maternalVar[0].description + ';' + maternalVar[1].description
                             maternalVar.forEach(pv => {

                                if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === pv.id)){
                                    let aux: DirectTestingDTO[] = newDirectTesting
                                    aux.push({
                                        id: uuidv4(),
                                        individualID: lastAdded.id,
                                        mutationID: pv.id,
                                        directTesting: 0,
                                        status: Status.Carrier
                                    })
            
                                    setNewDirectTesting(aux)
                                }
                    })
                            }
                        else if (maternalVar[1].trans) {
                            let aux: string[] = []
                            aux.push(maternalVar[0].description)
                            aux.push(maternalVar[1].description)

                            setChildVar(aux)

                            setOpenChildModalVariant(true)
                        }
                     }
            }
            setLastAdded(Object.assign({...lastAdded}, {'mutation': variantDescriptionAux, 'status': status}))

        }

    
    }

    const addVariants = (mutation: string)=>{

        let auxNewDT = []
        let auxMutation = variants.find( v => v.id === mutation)

        auxNewDT.push({
            id: uuidv4(),
            mutationID: mutation,
            individualID: lastAdded.id,
            directTesting: 0,
            status: Status.Carrier
        })

        setLastAdded(Object.assign({...lastAdded}, {'mutation': auxMutation?.description, 'status': 1}))

    }

    const selectVariantChild = (mutation: string) => {
        
        const parts = mutation
                        .split('/')
                        .flatMap(p => p.split(';'))
                        .flatMap(p => p.split(' or '))
                        .map(p => p.trim())


        const norm = (s: string) => s.trim().replace(/\s+/g, ' ')
        parts.forEach(m => {
            const vFound = variants.find(vs => norm(vs.description) === norm(m))
            if (!vFound) return
            const vId = vFound.id
            if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === vId)){
                let aux: DirectTestingDTO[] = newDirectTesting
                aux.push({
                    id: uuidv4(),
                    individualID: lastAdded.id,
                    mutationID: vId,
                    directTesting: 0,
                    status: Status.Carrier
                })
    
                setNewDirectTesting(aux)
            }
        })
  

        setLastAdded(Object.assign({...lastAdded}, {'mutation': mutation}))

    }

    const handleChange = (name: string, value: string | Number) => {
        if (name === 'status') aplyVariantDescription(Number(value)) 
        else setLastAdded(Object.assign({...lastAdded}, {[name]: value, 'mutation':''}))
    }

    const convertToFile = (f: File, data: string): FileDTO => ({
        id: uuidv4(),
        name: f.name,
        data,
        size: f.size,
        mimeType: f.type,
        extension: f.type.split('/')[1],
        ownerID: authService.get().id,
        pgType: ''
    })  
      const convertToFile2 = (f: File): FileDTO => ({
            id: uuidv4(),
            name: f.name,
            data: f,
            size: f.size,
            mimeType: f.type,
            extension: f.type.split('/')[1],
            ownerID: authService.get().id,
            pgType: ''
        })
    
        const toFormData = (f: File | Blob, id: string, extension: string) => {
            const formData = new FormData();

        
            let file: File;
        
            if (f instanceof Blob && !(f instanceof File)) {
                file = new File([f], 'nombre_archivo.bam', { type: f.type || 'application/octet-stream' });
            } else {
                file = f as File;
            }
            
            formData.append('data', file, file.name); 
            formData.append('id', id);
            formData.append('name', file.name);
            formData.append('mimeType', file.type || 'application/octet-stream'); 
            formData.append('size', file.size.toString());
            formData.append('extension', extension);
            formData.append('ownerID', authService.get().id);

            return formData;
        };

    const handleFileInput2 = async (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const fl = (event.target as HTMLInputElement).files
        if ((!fl?.length) || (fl[0].name.substring(fl[0].name.length - 4, fl[0].name.length) !== '.vcf') ){
            setErr(t('fileMustHaveVcfExtension'))
            setOpen(true)
            return
        }
      

        const data = await dataToBase64(fl[0])
        if (currentIndividual) {
            let file = new F(convertToFile(fl[0], data)).toDTO()
            file.extension = 'vcf'
            //@ts-ignore
            currentIndividual.file = file
            currentIndividual.fileName = fl[0].name

            setShowSpinner(true)
            individualService.update(currentIndividual.toDTO()).subscribe(() => {
                 let projectToSave = convertToProjectDTO(project as ProjectAnalysis)

        projectToSave.resultTableID = "00000000-0000-0000-0000-000000000000"
        setProject(projectToSave as any)
        props.setProject(projectToSave as any)
        projectService.update(projectToSave).subscribe((res) => {
            setIsLoading(true)
        })
            })
        }

        event.target.value = '';
    }

 const handleFileInput3 = async (
        event: ChangeEvent<HTMLInputElement>,
    ) => {
        const fl = (event.target as HTMLInputElement).files;
        if (!fl?.length) {
            return;
        }

        let bamFile: File | null = null;
        let baiFile: File | null = null;
        let bamID = '';
         let fail: boolean = true

        for (let i = 0; i < fl.length; i++) {
            const file = fl[i];
            if (file.name.endsWith('.bam')) {
                bamFile = file;
            } else if (file.name.endsWith('.bai')) {
                baiFile = file;
            }
        }


        if (bamFile) {
            setIsLoadingBamFiles2(true);
            let bamDTO = new F(convertToFile2(bamFile)).toDTO();
            bamDTO.extension = 'bam';

            let bamFileIndex = bamFiles.findIndex(
                (item) => item.individual == currentFileIndividual && item.extension == 'bam'
            );

            let newBamFile: File2 = {
                id: bamDTO.id,
                name: bamDTO.name,
                data: bamDTO.data,
                size: bamDTO.size,
                mimeType: bamDTO.mimeType,
                extension: bamDTO.extension,
                ownerID: bamDTO.ownerID,
                individual: currentFileIndividual || Individuals.CHILD,
                pgType: ''
            };

            let auxBamFiles = [...bamFiles];
            auxBamFiles[bamFileIndex] = newBamFile;
            setBamFiles(auxBamFiles);
            
            await fileService.addBIM2(toFormData(bamFile , bamDTO.id, bamDTO.extension))
            let individualsAux = individuals.filter(
                (f) => f.individual == currentFileIndividual
            );
            if (individualsAux.length > 0) {
                let individual = individualsAux[0];
                individual.bimFileID = bamDTO.id;

                let updatedIndividuals = individuals.map(i => 
                    i.individual == individual.individual ? individual : i
                );
                
                setIndividuals(updatedIndividuals);
       

                individualService.updateBamFiles(individual.toDTO());
                refreshData()
            }

            fail = false


        }

        if (baiFile) {
            setIsLoadingBamFiles2(true);
            let baiDTO = new F(convertToFile2(baiFile)).toDTO();
            baiDTO.extension = 'bai';

            let baiFileIndex = bamFiles.findIndex(
                (item) => item.individual == currentFileIndividual && item.extension == 'bai'
            );

            let newBaiFile: File2 = {
                id: baiDTO.id,
                name: baiDTO.name,
                data: baiDTO.data,
                size: baiDTO.size,
                mimeType: baiDTO.mimeType,
                extension: baiDTO.extension,
                ownerID: baiDTO.ownerID,
                individual: currentFileIndividual || Individuals.CHILD,
                pgType: ''
            };

            let auxBamFiles = [...bamFiles];
            auxBamFiles[baiFileIndex] = newBaiFile;
            setBamFiles(auxBamFiles);

            await fileService.addBAI2(toFormData(baiFile , baiDTO.id, baiDTO.extension))

            let individualsAux = individuals.filter(
                (f) => f.individual == currentFileIndividual
            );
            if (individualsAux.length > 0) {
                let individual = individualsAux[0];
                individual.baiFileID = baiDTO.id;

              
                let updatedIndividuals = individuals.map(i => 
                    i.individual == individual.individual ? individual : i
                );
                
                setIndividuals(updatedIndividuals);
                

                individualService.updateBamFiles(individual.toDTO());
                refreshData()
            }
            fail = false

            setIsLoadingBamFiles2(false);
        }

         setDisclaimerBambai(fail)

        event.target.value = '';
    };



    const handleFileInput = async (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const fl = (event.target as HTMLInputElement).files
        if ((!fl?.length) || (fl[0].name.substring(fl[0].name.length - 4, fl[0].name.length) !== '.vcf') ){
            setErr(t('fileMustHaveVcfExtension'))
            setOpen(true)
            return
        }

       

        const data = await dataToBase64(fl[0])
        let file = new F(convertToFile(fl[0], data)).toDTO()
        file.extension = 'vcf'

        let newIndividual = Object.assign(
            {...lastAdded},
            {file: file},
            //@ts-ignore
            {individual: lastAdded.individual},
            {fileName: fl[0].name},
            {informativityID: project?.informativityID},
            {projectID: project?.id},
        )

        if (newIndividual.individual === Individuals.FEMALE) setMotherStatus(newIndividual.status)
        if (newIndividual.individual === Individuals.MALE) setFatherStatus(newIndividual.status)
    
        if (lastAdded.individual === Individuals.CHILD) {
            setChildIndividual(lastAdded)
            setExistChild(true)
            project?.pathology === "X-Linked" && setModalChildGender(true)
        }

        console.log("aaaaaaaaaaa",newDirectTesting)

        setShowSpinner(true)
        if(newDirectTesting.length > 0){
            variants.map(v => {
                if(!newDirectTesting.find( dt => dt.individualID === lastAdded.id && dt.mutationID === v.id)){
                    let aux: DirectTestingDTO[] = newDirectTesting
                    aux.push({
                        id: uuidv4(),
                        individualID: lastAdded.id,
                        mutationID: v.id,
                        directTesting: 0,
                        status: Status.NonCarrier
                    })

                    setNewDirectTesting(aux)
                }
            })
            newDirectTesting.forEach(ndt => {
                directDetectionService.add(ndt)
            })
        }
        individualService.add(newIndividual).subscribe(() => {
            setLastAdded(emptyIndividualDTO(props.project?.id || ''))
            refreshInformativities()
            if(newDirectTesting.length > 0){
                newDirectTesting.forEach(ndt => {
                    directDetectionService.add(ndt)
                })
                setNewDirectTesting([])
            }
            let projectToSave = convertToProjectDTO(project as ProjectAnalysis)

        projectToSave.resultTableID = "00000000-0000-0000-0000-000000000000"
        setProject(projectToSave as any)
        props.setProject(projectToSave as any)
        projectService.update(projectToSave).subscribe((res) => {
            setIsLoading(true)
        })
            })
 
        event.target.value = '';
    }

    const [existChild, setExistChild] = useState<boolean>(false)

    const getColors = (individualType: Individuals) => {
        let colors = []

        switch (individualType) {
            case Individuals.FEMALE_FATHER:
                colors.push('rgb(3, 222, 108)')
                colors.push('rgb(221, 234, 251)')
                break
            case Individuals.FEMALE_BROTHER:
                colors.push('rgb(3, 222, 108)')
                colors.push('rgb(221, 234, 251)')
                break
            case Individuals.FEMALE:
                colors.push('rgb(237, 106, 250)')
                colors.push('rgb(3, 222, 108)')
                break
            case Individuals.MALE:
                colors.push('#ffd853')
                colors.push('#25e6e9')
                break
            case Individuals.CHILD:
                colors.push('rgb(237, 106, 250)')
                colors.push('#ffd853')
                break
            case Individuals.FEMALE_MOTHER:
                colors.push('rgb(237, 106, 250)')
                colors.push('rgb(221, 234, 251)')
                break
            case Individuals.MALE_MOTHER:
                colors.push('rgb(232, 216, 99)')
                colors.push('rgb(221, 234, 251)')
                break
            case Individuals.MALE_FATHER:
                colors.push('rgb(9, 214, 232)')
                colors.push('rgb(221, 234, 251)')
                break
            default:
                break
        }

        return colors
    }

    const deleteIndividual = (ind: Individual) => {
        setCurrentIndividual(ind)
        setIsViewData(true)
        setModalDeleteOpened(true)
    }

    const deleteConfirmed = (event: any) => {
        event.preventDefault()
        setShowSpinner(true)
        let projectToSave = convertToProjectDTO(project as ProjectAnalysis)
        if (currentIndividual?.individual == Individuals.CHILD) {
            setExistChild(false)
            projectToSave.childGender = ChildGenderPGD.Unknown
        }
        projectToSave.resultTableID = "00000000-0000-0000-0000-000000000000"
        projectService.update(projectToSave).subscribe((res) => {
        })

        individualService.delete(currentIndividual?.id || '').subscribe(() => {
            setModalDeleteOpened(false)
            setIsLoading(true)
            setLastAdded(emptyIndividualDTO(props.project?.id || ''))
        })
    }

    const closeModal = () => {
        setModalDeleteOpened(false)
        setCurrentIndividual(undefined)
    }

    const closeModalReplace = () => {
        setModalReplaceOpened(false)
        setCurrentIndividual(undefined)
    }

    const actionsDelete: FormAction[] = [
        {
            label: t('close'),
            handleAction: closeModal,
        },
    ]

    const actionsReplace: FormAction[] = [
        {
            label: t('close'),
            handleAction: closeModalReplace,
        },
    ]

    const replaceConfirmed = (event: any) => {
        event.preventDefault()
        setModalReplaceOpened(false)
        fileInputRef2.current?.click()
    }

    const handleContinue = () => {
        if (individuals.length > 0) {
            props.increaseStep()
        }
    }


    const handleChangeInformativity = (e: string) => {
        if (project) {
            
            if (e == undefined) {
                setIndividuals([])
                let auxProject = Object.assign({...project}, {informativityID: uuidv4(), resultTableID: nullId, parentsFasadeID: nullId, resultTableWithEmbryosID: nullId })
                setProject(auxProject)
                props.setProject(auxProject)
                projectService.update(auxProject)


                return
            }
            let auxProject = Object.assign({...project}, {informativityID: e, resultTableID: nullId, resultTableWithEmbryosID: nullId })
            setProject(auxProject)
            props.setProject(auxProject)

            setShowSpinner(true)
            projectService.update(auxProject).subscribe((res) => {
                setIsLoading(true)
            })  


            refreshData()

        }
    }
    const [modalChildGender, setModalChildGender] = useState<boolean>(false)
    const [childGender, setChildGender] = useState<ChildGenderPGD>(3)

    const replacedChildGender = (event: number) => {
        setChildGender(parseInt(event.toString(), 10))
    }

    const replacedChildFinalStatus = (event: FinalStatus) => {
        setChildFinalStatus(parseInt(event.toString(), 10))
    }

    const updateChildGender = (event?: React.FormEvent<HTMLFormElement>)  => {
        event?.preventDefault();
        if (props.project) {
            let projectToSave = convertToProjectDTO(project as ProjectAnalysis)
            projectToSave.childGender = childGender
            projectService.update(projectToSave).subscribe((res) => {
                setModalChildGender(false)
            })
        }
    }

    const updateChildCarrier = (event?: React.FormEvent<HTMLFormElement>)=> {
            event?.preventDefault();

            if (childIndividual ){
                if( childFinalStatus) childIndividual.finalStatus = childFinalStatus
            let individualsAux = individuals.filter(
                (f) => f.individual == childIndividual?.individual
            );
            if (individualsAux.length > 0) {
                let individual = individualsAux[0];
                individual.finalStatus = childIndividual.finalStatus;

                let updatedIndividuals = individuals.map(i => 
                    i.individual == individual.individual ? individual : i
                );
                
                setIndividuals(updatedIndividuals);
       
                individualService.update2(individual.toDTO()).subscribe(() => {
                    setModalChildOriginAffected(false)
                    runParentsSnipetsProcess()
                })
       
            }}

   
    }

    const checkContainsRequiredIndividuals = (individuals: Individual[]) => {
        const hasFemale = individuals.some(ind => ind.individual === Individuals.FEMALE);
        const hasMale = individuals.some(ind => ind.individual === Individuals.MALE);

        return hasFemale && hasMale ;
    }
    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpen(false)
    }
    const snackbarFunction = () => (
        <div>
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            style={{
                position: 'absolute',
                left: '50%',
                marginLeft: 'auto',
            }}>
            <Alert
                onClose={handleClose}
                severity={'error'}
                style={{
                    marginLeft: 'initial',
                }}>
                {err}
            </Alert>
        </Snackbar>
    </div>
    )

    const checkChildCarrier = () => {
        project?.pathology === "Recessive" && 
            fatherStatus === Status.Carrier && motherStatus === Status.Carrier &&
            childIndividual?.status === Status.Carrier? 
            setModalChildOriginAffected(true) : runParentsSnipetsProcess()
        
    }

    const runParentsSnipetsProcess = () => {
        if (!checkContainsRequiredIndividuals(individuals)) {
            setOpen(true)
            return
        }
        
        setProgress(0)
        setProgressMessage(t('progress.starting'))
        startProgressPolling()
        setModalPreviewOpened(true)
        setDataLoaded(false)
        props.setIndividuals(individuals)
        console.log("project",project)
        individualService.runParentsSnipetsProcess(project?.id || '').subscribe((res: any) => {
            let auxRes = res
            // let auxRes2
            if (res) {
                auxRes.preProcessedData = auxRes.preProcessedData.map((item: any) => ({
                    ...item,
                    seeEmbryo: true,
                }))
                // project?.pathology === "Recessive"? auxRes2 = calculateCarrierChild(auxRes) : auxRes2 = res
            }
            setIsLoading(true)
            setDataLoaded(true)
            setIsViewData(false)
            props.setData(auxRes)
            props.setIsViewResult(true)
            stopProgressAndHide()
        })
    }

    console.log("project2",project)

    useEffect(() => {
        if (project?.resultTableID != "00000000-0000-0000-0000-000000000000") {
            setIsViewData(false)
        }
        if (project){
        let auxMaternalVar: MutationsPosition[]=[]
        let auxPaternalVar: MutationsPosition[]=[]
        mutationService.getByProjectID(project.mutationPositionsID || '').subscribe(resV => {
        
            if (resV){
                setVariants(resV.items)
                resV.items.map(variant => {
                    if (variant.paternal === 'mother') auxMaternalVar.push(variant)
                    if(variant.paternal === 'father') auxPaternalVar.push(variant)
        
                })
            }

            setMaternalVar(auxMaternalVar)
            setPaternalVar(auxPaternalVar)
         
        })}

    }, [project]);

    const openModalIGV = () => {
        props.setViewIGV(true)
        props.setVariants(variants)
    }

    const [progress, setProgress] = useState<number>(0)
    const [progressMessage, setProgressMessage] = useState<string>('')
    const progressTimerRef = useRef<any>(null)
    const [isProgressActive, setIsProgressActive] = useState<boolean>(false)
 
     const startProgressPolling = () => {
         stopProgressPolling()
         const id = project?.id
         if (!id) return
         setIsProgressActive(true)
         const poll = () => {
             individualService.getProgress(id).subscribe((data: any) => {
                 if (typeof data?.percent === 'number') setProgress(data.percent)
                 if (typeof data?.message === 'string') setProgressMessage(data.message)
                 if (data?.error) {
                     stopProgressPolling()
                 }
                 if (data?.done) {
                     setProgress(100)
                     stopProgressPolling()
                 }
             })
         }
         progressTimerRef.current = setInterval(poll, 1200)
         poll()
     }
 
     const stopProgressPolling = () => {
         if (progressTimerRef.current) {
             clearInterval(progressTimerRef.current)
             progressTimerRef.current = null
         }
     }
 
     const stopProgressAndHide = () => {
         stopProgressPolling()
         setIsProgressActive(false)
     }

    useEffect(() => {
        return () => stopProgressPolling()
    }, [])

    const progressMsgKey: Record<string, string> = {
        'Starting': 'starting',
        'Not started': 'notStarted',
        'Loading project': 'loadingProject',
        'Loading your analysis': 'loadingProject',
        'Loading individuals and data': 'loadingIndividuals',
        'Preparing family data': 'loadingIndividuals',
        'Grouping individuals': 'grouping',
        'Organizing family data': 'grouping',
        'Loading existing results': 'loadingExistingResults',
        'Loading saved results': 'loadingExistingResults',
        'Processing parents-only data': 'parentsOnly',
        'Processing parents': 'parentsOnly',
        'Processing family groups': 'processingGroups',
        'Typing alleles and filling lines': 'typingAlleles',
        'Checking informative positions': 'typingAlleles',
        'Marking variants and saving data': 'markingVariants',
        'Flagging variant positions': 'markingVariants',
        'Phasing parental markers': 'phasingParentalMarkers',
        'Summarizing family status': 'summarizingStatus',
        'Saving results': 'savingResults',
        'Preparing data for view': 'preparingView',
        'Loading sample data': 'loadingSamples',
        'Loading sample files': 'loadingSampleFiles',
        'Updating sample records': 'updatingSamples',
        'Counting regions': 'countingRegions',
        'Aligning child with parents': 'aligningChild',
        'Merging results': 'mergingResults',
        'Filtering non-informative positions': 'filteringNonInformative',
        'Loading allele labels': 'loadingAlleleLabels',
        'Assessing inheritance pattern': 'assessingInheritance',
        'Finalizing layout': 'finalizingLayout',
        'Finalizing': 'finalizing',
        'Final touches': 'finalizing',
        'Completed': 'completed',
        'Loading result entries': 'loadingResultEntries',
    }

    return (
        <>
            <Typography
                style={{
                    fontSize: '17px',
                    fontWeight: 'bold',
                    color: 'rgb(125, 191, 220)',
                    marginBottom: '0.5%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
                >
                <Box>{t('informativity').toLocaleUpperCase() } - {projectName}</Box>
                <Box>{`v${props?.project?.version}`}</Box>
            </Typography>
            <Divider style={{marginBottom: '2%', width: '100%'}}/>
            <Grid item xs={12} style={{marginBottom: '2.5%'}}>
                <Grid item xs={4} style={{marginBottom: '3%'}}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel id="selectInformativity">{t('selectInformativity')}</InputLabel>
                        <Select
                            labelId="selectInformativity"
                            id="selectInformativity"
                            fullWidth
                            style={{textAlign: 'left'}}
                            disabled={!canEdit}
                            value={project?.informativityID}
                            onChange={(e) => e && handleChangeInformativity(e.target.value as string)}
                            label={t('selectInformativity')}>
                            {informativities
                                .filter((l) => l.name)
                                .map((l, i) => (
                                    <MenuItem value={l.id} key={l.id}>
                                        {l.name || l.id}
                                    </MenuItem>
                                ))}
                            <MenuItem value={undefined} key={undefined}>
                                {t('doNotSelect')}
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {!isLoading && !showSpinner ? (
                    <TableContainer>
                        <Table>
                            <Head
                                fields={fields}
                                styleHeader={{fontWeight: 'bold', color: 'rgb(125, 191, 220)'}}
                                actions={actions}
                            />
                            <Body actions={actions} fields={fields} items={[]} rowKeyField={DEFAULT_ROW_KEY}/>
                            {individuals.map((ind, index) => (
                                <TableRow>
                                    <TableCell key="individual" className={styles.selectCell}>
                                        {individualsTitle()[ind.individual]}
                                    </TableCell>
                                    <TableCell key="fileName">{ind.fileName}</TableCell>

                                    <TableCell key="status" className={styles.selectCell}>
                                        {statusTitle()[ind.status]}
                                    </TableCell>
                                    <TableCell key="mutation">{ind.mutation !== '' ? ind.mutation : '-'}</TableCell>
                                    <TableCell key="color">
                                        <div className={styles.row}>
                                            {getColors(ind.individual)?.map((c) => (
                                                <div className={styles.colorsRow} style={{backgroundColor: c}}/>
                                            ))}
                                        </div>
                                    </TableCell>
                                    <TableCell key="actions">
                                        <Box display="flex" justifyContent="space-between">
                                        {  canEdit &&  <GenericTooltip
                                                values={[t('delete')]}
                                                icon={
                                                    <img
                                                        src={deleteIcon}
                                                        alt=''
                                                        className={styles.imgAction}
                                                        onClick={() => deleteIndividual(ind)}
                                                    />
                                                }
                                                noUseFab={true}
                                            />}
                                            <GenericTooltip
                                                values={[t('download2')]}
                                                icon={
                                                    <img
                                                        src={downloadIcon}
                                                        alt=''
                                                        className={styles.imgAction}
                                                        onClick={() =>
                                                            downloadFile(
                                                                ind.file?.name || '',
                                                                ind.file?.mimeType || '',
                                                                ind.file?.data || ''
                                                            )
                                                        }
                                                    />
                                                }
                                                noUseFab={true}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                         { canEdit && <TableRow>
                                <TableCell key="individual" className={styles.selectCell}>
                                    <Select
                                        className={styles.select}
                                        variant="outlined"
                                        value={lastAdded.individual}
                                        onChange={(e: any) => handleChange('individual', Number(e.target.value))}>
                                        {individualOptions
                                            .filter((i) => !individuals.map((i) => i.individual).includes(i))
                                            .map((l) => {
                                              const hasFemaleFather = individuals.some(i => i.individual === Individuals.FEMALE_FATHER);
                                                const hasFemaleBrother = individuals.some(i => i.individual === Individuals.FEMALE_BROTHER);

                                                if (
                                                    (l === Individuals.FEMALE_BROTHER && project?.pathology !== 'X-Linked') ||
                                                    (l === Individuals.FEMALE_BROTHER && hasFemaleFather) ||
                                                    (l === Individuals.FEMALE_FATHER && hasFemaleBrother)
                                                ) {
                                                    return null;
                                                }
                                            
                                                return (
                                                    <MenuItem value={l} key={l} selected={l === lastAdded.individual}>
                                                        {/* @ts-ignore */}
                                                        {individualsTitle()[l]}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </TableCell>
                                <TableCell key="fileName">{lastAdded.fileName}</TableCell>

                                <TableCell key="status" className={styles.selectCell}>
                                <Select
                                        className={styles.select}
                                        variant="outlined"
                                        value={lastAdded.status}
                                        onChange={(e: any) => handleChange('status', e.target.value)}>
                                        {statusOptions.map((l) =>  {
                                             if (!(project?.pathology === 'X-Linked' && (lastAdded.individual === 0 || lastAdded.individual ===2 ||
                                                 lastAdded.individual ===6) && statusTitle()[l]==="Carrier" )&&
                                                  !(project?.pathology === 'Dominant' && statusTitle()[l]==="Carrier" )&&
                                                  !(((lastAdded.individual ===2 &&( paternalVar[0]?.trans || paternalVar[1]?.trans)) || 
                                                (lastAdded.individual === 1 &&( maternalVar[0]?.trans || maternalVar[1]?.trans)))&& statusTitle()[l]==="Carrier")){
                                                return(
                                                <MenuItem value={l} key={l} selected={l == lastAdded.status}>
                                                {statusTitle()[l]}
                                                </MenuItem>)
                                            }}
                                        )}
                                    </Select>
                                </TableCell>
                                <TableCell key="mutation">
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        rows={1}
                                        value={lastAdded.mutation}
                                        onChange={(e: any) => handleChange('mutation', e.target.value)}
                                    />
                                </TableCell>
                                <TableCell key="color">
                                    <div className={styles.row}>
                                        {getColors(lastAdded.individual)?.map((c) => (
                                            <div className={styles.colorsRow} style={{backgroundColor: c}}/>
                                        ))}
                                    </div>
                                </TableCell>
                                <TableCell key="actions">
                                    {lastAdded.individual != Individuals.UNKNOWN &&
                                    lastAdded.status != Status.Null ? (
                                        <Box display="flex" justifyContent="space-between">
                                            {actions.items.map((a) => {
                                                return (
                                                    <GenericTooltip
                                                        values={[t(a.label || a.icon)]}
                                                        icon={
                                                            <img
                                                                src={a.icon}
                                                                alt=''
                                                                className={styles.imgAction}
                                                                onClick={() => a.handler(lastAdded)}
                                                            />
                                                        }
                                                        noUseFab={true}
                                                    />
                                                )
                                            })}
                                        </Box>
                                    ) : null}
                                </TableCell>
                            </TableRow>}
                        </Table>
                    </TableContainer>
                ) : (
                    <Box>
                        <CircularProgress/>
                    </Box>
                )}

                {(!isLoadingBamFiles && !isLoadingBamFiles2) ? (
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>} // Icono para expandir el acordeón
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography
                                style={{
                                    fontSize: '17px',
                                    fontWeight: 'bold',
                                    color: 'rgb(125, 191, 220)',
                                    marginBottom: '0.5%',
                                    marginTop: '5%',
                                }}
                                align="left"
                            >
                                {t('bamFiles').toLocaleUpperCase()}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <AppTable
                                styleHeader={{color: COLOR_CLINICS}}
                                actions={canEdit ? actionsFiles : undefined}
                                fields={fieldsFiles}
                                items={bamFiles}
                                rowKeyField={'id'}
                            />
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <Box>
                        <CircularProgress/>
                    </Box>
                )}

                {disclaimerBambai && 
                    <Box style={{marginTop: "10px", color: "red"}}>
                        *{t('bambaiFail')}
                    </Box>
                }

            { project?.updated && <Box
                style={{marginTop: "10px", color: "Red"}}
             >
                *{t('updatedProject')}
            </Box>}

                <input
                    onChange={(event) => handleFileInput(event)}
                    multiple={false}
                    ref={fileInputRef}
                    type="file"
                    hidden
                />
                <input
                    onChange={(event) => handleFileInput2(event)}
                    multiple={false}
                    ref={fileInputRef2}
                    type="file"
                    hidden
                />
                {/*<input
                    onChange={(event) => handleFileInput3(event, 'bai')}
                    multiple={false}
                    ref={fileInputRefBAI}
                    type="file"
                    hidden
                    accept=".bai"
                />*/}
                <input
                    onChange={(event) => handleFileInput3(event)}
                    multiple={true}
                    ref={fileInputRefBAMBAI}
                    type="file"
                    hidden
                    accept=".bam,.bai"
                />

                <Grid item xs={12} className={styles.backButtonGrid} style={{marginTop: '3%'}}>
                    <Button
                        variant="contained"
                        startIcon={<ArrowBack/>}
                        onClick={props.decreaseStep}
                        className={styles2.button}
                        style={{display: 'flex', alignSelf: 'flex-start'}}>
                        {t('back2')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={checkChildCarrier}
                        className={styles2.button}
                        style={{display: 'flex', alignSelf: 'flex-start'}}>
                        {t('runProcess')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={openModalIGV}
                        className={styles2.button}
                        disabled={validDirectDetection()}
                        style={{display: 'flex', alignSelf: 'flex-start'}}>
                        {t('igvButton')}
                    </Button>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForward/>}
                        onClick={openSaveInformativityModal}
                        className={styles2.button}
                        disabled={isViewData}
                        style={{display: 'flex', alignSelf: 'flex-start'}}>
                        {t('continue')}
                    </Button>
                </Grid>
            {snackbarFunction()}

            </Grid>

            <Modal open={modalDeleteOpened}>
                <Box className={styles2.modal}>
                    <form onSubmit={deleteConfirmed}>
                        <Box mt={2} textAlign={'justify'}>
                            {t('individualConfirmationMessage')}
                        </Box>
                        <FormActions actions={actionsDelete} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            <Modal open={modalReplaceOpened}>
                <Box className={styles2.modal}>
                    <form onSubmit={replaceConfirmed}>
                        <Box mt={2} textAlign={'justify'}>
                            {t('individualReplaceConfirmationMessage')}
                        </Box>
                        <FormActions actions={actionsReplace} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            <Modal open={modalChildGender}>
                <Box className={styles2.modal}>
                    <form onSubmit={updateChildGender}>
                            <Box mt={2} textAlign={'justify'}>
                                {t('selectChildGender')}
                            </Box>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="inherit-label">{t('childGender')}</InputLabel>
                                <Select
                                    labelId="childGender"
                                    id="childGender"
                                    fullWidth
                                    style={{textAlign: 'left'}}
                                    value={(data && data.childGender) || childGender}
                                    onChange={(event) => replacedChildGender(event.target.value as number)}
                                    label={t('childGender')}>
                                    {Object.entries(childGendersPGD())
                                        .filter(([k, v]) => v !== 'Unknown')
                                        .map(([key, value]) => {
                                            if (!(project?.pathology === 'X-Linked' && childIndividual?.status === 1 && value === t('Male') )) {return <MenuItem value={key}>{value}</MenuItem>}
                                        })}
                                </Select>
                                
                            </FormControl>
                        <FormActions actions={actionReplaceModalChildGender} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            <Modal open={openPaternalModalVariant}>
                <Box className={styles2.modal}>
                    <form onSubmit={closeVarianModal}>
                            <Box mt={2} textAlign={'justify'}>
                                {t('selectVariant')}
                            </Box>
                            <FormControl fullWidth variant="outlined">
                                <Select
                                    labelId="selectVariant"
                                    id="selectVariant"
                                    fullWidth
                                    style={{textAlign: 'left'}}
                                    value={lastAdded.mutation}
                                    onChange={(event) => addVariants(event.target.value as string)}
                                 >
                                    {paternalVar
                                        .map((value) => {
                                             return <MenuItem value={value.id}>{value.description}</MenuItem>
                                        })}
                                </Select>
                                
                            </FormControl>
                        <FormActions actions={actionVariantModal} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            <Modal open={openModalMaternalVariant}>
                <Box className={styles2.modal}>
                    <form onSubmit={closeVarianModal}>
                            <Box mt={2} textAlign={'justify'}>
                                {t('selectVariant')}
                            </Box>
                            <FormControl fullWidth variant="outlined">
                                <Select
                                    labelId="selectVariant"
                                    id="selectVariant"
                                    fullWidth
                                    style={{textAlign: 'left'}}
                                    value={lastAdded.mutation}
                                    onChange={(event) => addVariants(event.target.value as string)}
                                
                                 >
                                    {maternalVar
                                        .map((value) => {
                                             return <MenuItem value={value.id}>{value.description}</MenuItem>
                                        })}
                                </Select>
                                
                            </FormControl>
                        <FormActions actions={actionVariantModal} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            <Modal open={openModalChildlVariant}>
                <Box className={styles2.modal}>
                    <form onSubmit={closeVarianModal}>
                            <Box mt={2} textAlign={'justify'}>
                                {t('selectVariant')}
                            </Box>
                            <FormControl fullWidth variant="outlined">
                                <Select
                                    labelId="selectVariant"
                                    id="selectVariant"
                                    fullWidth
                                    style={{textAlign: 'left'}}
                                    value={lastAdded.mutation}
                                    onChange={(event) => selectVariantChild(event.target.value as string)}
                                
                                 >
                                    {childVar
                                        .map((value) => {
                                             return <MenuItem value={value}>{value}</MenuItem>
                                        })}
                                </Select>
                                
                            </FormControl>
                        <FormActions actions={actionVariantModal} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            <Modal open={modalChildOriginAffected}>
                <Box className={styles2.modal}>
                    <form onSubmit={updateChildCarrier}>

                            <Box mt={2} textAlign={'justify'}>
                                {t('selecOriginAffected')}
                            </Box>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="inherit-label">{t('originAffected')}</InputLabel>
                                <Select
                                    labelId="originAffected"
                                    id="originAffected"
                                    fullWidth
                                    style={{textAlign: 'left'}}
                                    value={(childFinalStatus) || childIndividual?.finalStatus}
                                    onChange={(event) => replacedChildFinalStatus(event.target.value as FinalStatus)}
                                    label={t('originAffected')}>
                                        <MenuItem value={FinalStatus.CarrierFromMother}>{"Carrier from mother"}</MenuItem>
                                        <MenuItem value={FinalStatus.CarrierFromFather}>{"Carrier from father"}</MenuItem>

                                </Select>
                                
                            </FormControl>
                        <FormActions actions={actionReplaceModalCarrierAfected} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

            {!dataLoaded && (
                <Modal open={!dataLoaded && (modalPreviewOpened || isProgressActive)}>
                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                        {isProgressActive ? (
                            <Box style={{ width: 360, background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}>
                                <LinearProgress variant="determinate" value={progress} />
                                <Box mt={2}>
                                    <Typography variant="body2" align="center" style={{ color: '#333' }}>
                                        {(() => {
                                            const token = progressMsgKey[progressMessage]
                                            return token ? t(`progress.${token}`) : (progressMessage || `${progress}%`)
                                        })()}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            <CircularProgress className={styles.circularProgress}/>
                        )}
                    </Box>
                 </Modal>
             )}

            <Modal open={modalSaveInformativityOpened}>
                <Box className={styles2.modal}>
                    <form onSubmit={saveInformativity}>
                        <Box mt={2} textAlign={'justify'}>
                            {t('informativityNameModalMessage')}
                        </Box>
                        <Box mt={2} textAlign={'justify'}>
                            <TextField
                                fullWidth
                                variant={'outlined'}
                                id={'name'}
                                type={'string'}
                                onChange={(event) => handleNameInformativity('name', event.target.value)}
                                value={nameInformativity || ''}
                                label={t('informativityName')}
                            />
                        </Box>
                        <FormActions actions={actionReplaceModalInformativity} message={t('confirm')}/>
                    </form>
                </Box>
            </Modal>

           
        </>
    )
}
